/**
 * ProcessPage — /process spoke route.
 * Re-uses the Process section component from the homepage.
 */
import { Helmet } from 'react-helmet-async';
import { Link } from '@tanstack/react-router';
import SchemaJsonLd from '../components/primitives/SchemaJsonLd.jsx';
import Eyebrow from '../components/ui/Eyebrow.jsx';
import Button from '../components/ui/Button.jsx';
import Process from '../components/sections/Process.jsx';

const processBreadcrumb = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://artificersai.com/' },
    { '@type': 'ListItem', position: 2, name: 'Process', item: 'https://artificersai.com/process' },
  ],
};

export default function ProcessPage() {
  return (
    <>
      <Helmet>
        <title>How We Ship — Five-Phase Delivery Playbook | The Artificer's AI</title>
        <meta name="description" content="Discovery to scale. The five-phase shape every Fully Automated Business Systems engagement runs through." />
        <link rel="canonical" href="https://artificersai.com/process" />
        <meta property="og:title" content="How We Ship — Five-Phase Delivery Playbook" />
        <meta property="og:description" content="Discovery to scale. The five-phase shape every Fully Automated Business Systems engagement runs through." />
        <meta property="og:url" content="https://artificersai.com/process" />
      </Helmet>

      {/* Intro */}
      <section className="section-pad bg-surface text-ink-50">
        <div className="container-page max-w-prose">
          <Eyebrow className="mb-4">Process</Eyebrow>
          <h1 className="text-display-lg font-display font-semibold mb-4">How we ship automated systems</h1>
          <p className="text-body-lg text-ink-200">
            The five-phase shape every Fully Automated Business Systems engagement runs through.
          </p>
        </div>
      </section>

      {/* Reuse the Process section component */}
      <Process />

      {/* CTA + cross-links */}
      <section className="section-pad bg-surface text-ink-50 border-t border-white/[.06]">
        <div className="container-page max-w-prose">
          <div className="flex flex-col gap-4 mb-10">
            <Link to="/automated-systems" className="text-body text-brand-blue-bright hover:text-brand-blue-pale transition-colors">
              See the offer this process describes
            </Link>
          </div>
          <Button as={Link} to="/intake">Scope a system</Button>
        </div>
      </section>

      <SchemaJsonLd data={processBreadcrumb} />
    </>
  );
}
